/* Navigation only: observe the native product event, never change its form. */
(() => {
  'use strict';
  if (customElements.get('birthstone-month-navigation')) return;
  const id = value => Number.isSafeInteger(Number(value)) && Number(value) > 0 ? String(value) : null;
  const pair = (variant, pendantProductId) => {
    const parts = variant?.components;
    if (!Array.isArray(parts) || parts.length !== 2 || parts.some(part =>
      part.type !== 'Simple' || part.quantity_in_bundle !== 1 || !id(part.variant_id) || !id(part.product_id))) return null;
    const pendants = parts.filter(part => id(part.product_id) === id(pendantProductId));
    const chains = parts.filter(part => id(part.product_id) !== id(pendantProductId));
    return pendants.length === 1 && chains.length === 1
      ? {chainId: id(chains[0].variant_id), pendantId: id(pendants[0].variant_id)} : null;
  };
  class BirthstoneMonthNavigation extends HTMLElement {
    connectedCallback() {
      if (this.onVariantChange) return;
      try { this.data = JSON.parse(this.querySelector('[data-month-navigation-data]').textContent); }
      catch (_) { this.hidden = true; return; }
      this.productRoot = this.closest('[data-section-type="product"]');
      if (!this.productRoot) { this.hidden = true; return; }
      this.onVariantChange = event => this.update(event.detail?.variant?.id);
      this.productRoot.addEventListener('variantChange', this.onVariantChange);
      const selected = this.productRoot.querySelector('[data-product-select]');
      this.update(this.data.variantId || selected?.value);
    }
    disconnectedCallback() {
      if (this.onVariantChange) this.productRoot?.removeEventListener('variantChange', this.onVariantChange);
      this.onVariantChange = null;
    }
    update(variantId) {
      const own = this.data.months.filter(month => id(month.id) === id(this.data.productId));
      const ownVariants = own.length === 1 ? own[0].variants.filter(variant => id(variant.id) === id(variantId)) : [];
      const current = ownVariants.length === 1 ? pair(ownVariants[0], this.data.pendantProductId) : null;
      const counts = new Map();
      this.data.months.forEach(month => counts.set(id(month.id), (counts.get(id(month.id)) || 0) + 1));
      let visible = 0;
      this.querySelectorAll('[data-month-product]').forEach(item => {
        const productId = id(item.dataset.monthProduct);
        const month = this.data.months.find(value => id(value.id) === productId);
        const matches = current && month && counts.get(productId) === 1
          ? month.variants.filter(variant => pair(variant, this.data.pendantProductId)?.chainId === current.chainId) : [];
        const target = matches.length === 1 ? matches[0] : null;
        const pendantId = target ? pair(target, this.data.pendantProductId).pendantId : null;
        const pendants = this.data.pendants.filter(value => id(value.id) === pendantId);
        const pendant = pendants.length === 1 ? pendants[0] : null;
        const anchor = item.querySelector('a');
        let url;
        try {
          url = new URL(month.url, location.origin);
          if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+$/.test(url.pathname)) throw new Error('Invalid product URL');
        } catch (_) { url = null; }
        item.hidden = !target || !pendant || !url;
        if (item.hidden) { anchor.removeAttribute('href'); return; }
        visible++;
        url.searchParams.set('variant', target.id);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
        anchor.href = url.pathname + url.search;
        if (productId === id(this.data.productId)) anchor.setAttribute('aria-current', 'page');
        else anchor.removeAttribute('aria-current');
        item.querySelector('.birthstone-month-navigation__label').textContent = pendant.name;
        let image = item.querySelector('img');
        if (target.image) {
          if (!image) { image = document.createElement('img'); image.className = 'birthstone-month-navigation__image'; image.loading = 'lazy'; item.querySelector('.birthstone-month-navigation__image-frame').append(image); }
          image.removeAttribute('srcset');
          image.src = target.image;
          image.alt = pendant.name;
          image.width = 64;
          image.height = 64;
        } else if (image) image.remove();
      });
      this.hidden = visible === 0;
    }
  }
  customElements.define('birthstone-month-navigation', BirthstoneMonthNavigation);
})();
